import { render, staticRenderFns } from "./DetailSpri.vue?vue&type=template&id=00f9cd2d&scoped=true"
import script from "./DetailSpri.vue?vue&type=script&lang=js"
export * from "./DetailSpri.vue?vue&type=script&lang=js"
import style0 from "./DetailSpri.vue?vue&type=style&index=0&id=00f9cd2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f9cd2d",
  null
  
)

export default component.exports